// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itadashpg-inline-1 {
  padding: 0;
}

.itadashpg-inline-2 {
  font-family: monospace;
  font-size: 11px;
}

.itadashpg-inline-3 {
  font-weight: 600;
}

.itadashpg-inline-4 {
  color: #94a3b8;
}

.itadashpg-inline-5 {
  font-size: 12px;
  font-weight: 600;
}

.itadashpg-inline-6 {
  font-size: 10.5px;
  color: #94a3b8;
}

.itadashpg-inline-7 {
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  padding: 12px;
}

.itadashpg-inline-8 {
  font-size: 12px;
  font-weight: 600;
}

.itadashpg-inline-9 {
  font-size: 11px;
  color: #94a3b8;
}

.itadashpg-inline-10 {
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
  padding: 12px;
}

.itadashpg-inline-11 {
  font-size: 12px;
  font-weight: 600;
}

.itadashpg-inline-12 {
  font-size: 11px;
  color: #94a3b8;
}

.itadashpg-dyn-1 {
  border-left: var(--itadashpg-1-border-left);
}

.itadashpg-dyn-2 {
  color: var(--itadashpg-2-color);
}

.itadashpg-dyn-3 {
  color: var(--itadashpg-3-color);
}

.itadashpg-dyn-4 {
  padding: 8px 0;
  border-bottom: var(--itadashpg-4-border-bottom);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/ITAdmin/ITADashPg.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,+CAA+C;AACjD","sourcesContent":[".itadashpg-inline-1 {\n  padding: 0;\n}\n\n.itadashpg-inline-2 {\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.itadashpg-inline-3 {\n  font-weight: 600;\n}\n\n.itadashpg-inline-4 {\n  color: #94a3b8;\n}\n\n.itadashpg-inline-5 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.itadashpg-inline-6 {\n  font-size: 10.5px;\n  color: #94a3b8;\n}\n\n.itadashpg-inline-7 {\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: center;\n  padding: 12px;\n}\n\n.itadashpg-inline-8 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.itadashpg-inline-9 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itadashpg-inline-10 {\n  font-size: 12px;\n  color: #94a3b8;\n  text-align: center;\n  padding: 12px;\n}\n\n.itadashpg-inline-11 {\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.itadashpg-inline-12 {\n  font-size: 11px;\n  color: #94a3b8;\n}\n\n.itadashpg-dyn-1 {\n  border-left: var(--itadashpg-1-border-left);\n}\n\n.itadashpg-dyn-2 {\n  color: var(--itadashpg-2-color);\n}\n\n.itadashpg-dyn-3 {\n  color: var(--itadashpg-3-color);\n}\n\n.itadashpg-dyn-4 {\n  padding: 8px 0;\n  border-bottom: var(--itadashpg-4-border-bottom);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
